var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-screen-banner-box"},[_c('img',{ref:"imageElement",attrs:{"src":_vm.contentUrl,"rel":"preload"}}),_c('div',{staticClass:"countdown"},[_vm._v(_vm._s(_vm.secondsLeft))])])
}
var staticRenderFns = []

export { render, staticRenderFns }